import { useRef, useState, useEffect } from 'react';

const useComponentVisible = initIsVisible => {
  const [isComponentVisible, setisComponentVisible] = useState(initIsVisible);
  const ref = useRef(null);

  // Handle Keyboard events
  const handleHideContainer = event => {
    if (event.key === 'Escape') {
      setisComponentVisible(false);
    }
  };
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setisComponentVisible(false);
    }
  };

  // Bind click and keydown event handlers
  useEffect(() => {
    document.addEventListener('keydown', handleHideContainer, true);
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('keydown', handleHideContainer, true);
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  return { ref, isComponentVisible, setisComponentVisible };
};

export default useComponentVisible;
